import React from "react";
import { Dialog } from "primereact/dialog";
import "./CommonModal.scss";
import { SvgIcon } from "../svgIcon/SvgIcon";

interface CommonModalProps extends Omit<
  React.HTMLAttributes<HTMLDivElement>,
  "onSubmit"
> {
  isOpen?: boolean;
  onClose: () => void;
  children?: React.ReactNode;
  actions?: React.ReactNode;
  icon: string;
  onSubmit?: (e: React.FormEvent<HTMLFormElement>) => void;
  formId?: string;
  hasForm?: boolean;
  width?: number;
  height?: number;
  closeIcon?: boolean;
}

export const CommonModal: React.FC<CommonModalProps> = ({
  isOpen = false,
  onClose,
  closeIcon,
  children,
  actions,
  className = "",
  icon,
  onSubmit,
  formId,
  width,
  height,
  hasForm = false,
  ...divProps
}) => {
  const isMobile = window.innerWidth < 768;

  const handleFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    if (onSubmit) {
      onSubmit(e);
    }
  };

  const modalContent = (
    <>
      <div className={`commonModal-header ${icon === "" ? "noIcon" : ""}`}>
        {icon !== "" ? (
          <div className="commonModal-icon">
            <SvgIcon icon={icon} />
          </div>
        ) : (
          <div />
        )}
        <div
          className={`commonModal-close close-${closeIcon}`}
          onClick={onClose}
        >
          <SvgIcon icon="icon-close" />
        </div>
      </div>
      <div className="commonModal-body">{children}</div>
      <div
        className="commonModal-footer"
        style={{ marginBottom: hasForm ? "1.25rem" : 0 }}
      >
        {actions}
      </div>
    </>
  );

  return (
    <Dialog
      visible={isOpen}
      onHide={onClose}
      header={null}
      footer={null}
      closable={false}
      focusOnShow={false}
      modal
      dismissableMask
      appendTo={document.body}
      blockScroll
      baseZIndex={9999}
      className={`commonModal ${className}`}
      style={{
        width: isMobile ? "95vw" : width ? `${width}px` : "520px",
        // Remove height — let content define it naturally
      }}
      pt={{
        content: { style: { padding: 0, borderRadius: "inherit" } },
        root: { style: { borderRadius: "1rem", overflow: "hidden" } },
      }}
    >
      {hasForm ? (
        <form id={formId} onSubmit={handleFormSubmit}>
          {modalContent}
        </form>
      ) : (
        modalContent
      )}
    </Dialog>
  );
};
